import React, { Fragment } from "react"
import { Styled } from "theme-ui"

export default () => (
  <Fragment>
    <Styled.a href="https://mnmadventureel.com/">M. & M. Hollstein</Styled.a>
    <br />
    We are M. & M. Hollstein. We are just a couple of goofs who enjoy traveling around the world for our vacations. We also enjoy sharing our experiences with others. This could be for your entertainment or to get some helpful insights into your own travels. We appreciate your time spent with us. During our off time we enjoy spending time with our Golden Retreiver - Lacey, watching spooky movies and documentaries, pop culture, and reading exciting fiction novels.
  </Fragment>
)